"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
exports.default = {
    CONNECT_JS_CLIENT_ID: process.env.CONNECT_JS_CLIENT_ID || 'Arketype',
    CONNECT_JS_REALM: process.env.CONNECT_JS_REALM || 'Arkane',
    CONNECT_JS_SSL_REQUIRED: process.env.CONNECT_JS_SSL_REQUIRED || 'external',
    CONNECT_JS_PUBLIC_CLIENT: process.env.CONNECT_JS_PUBLIC_CLIENT || 'true',
    CONNECT_JS_INTERCOM_APP_ID: process.env.CONNECT_JS_INTERCOM_APP_ID || 'geuh54pb',
};
/* tslint:enable */
//# sourceMappingURL=env.js.map